module.exports = __webpack_public_path__ + "assets/img/logoauc.33ca95f7.svg";